import { createSlice } from "@reduxjs/toolkit";
import { PURGE } from 'redux-persist';
import { UtilityFunctions } from "../../../utils";

const initialState = {
    productInformation: {
        rowId: 0,
        workOrderId: '',
        productCode: '',
        startingTime: '00:00', 
        endingTime: '00:00', 
        hungCount: 0,
        hasBeenConfirmed: false,
    },
    enamelPaintingForm: {
        enamelPaintingFormId: 0,
        date: UtilityFunctions.formatDate(new Date().toLocaleString()),
        rows: [],
        confirmData: {
            qaTechnician: false,
            qaEngineer: false,
            name: ''
        },
        shiningLotNo: 0, 
        dullLotNo: 0,
        totalCount: 0,
        hasBeenEmailed: false,
    },
    enamelPaintingForms: [],
};

const enamelPaintingFormSlice = createSlice({
    name: 'enamelPaintingForm',
    initialState,
    reducers: {
        setEnamelPaintingForm: (state, action) => {
            state.enamelPaintingForm = action.payload;
        },
        setProductInformation: (state, action) => {
            state.productInformation = action.payload;
        },
        setProductCode: (state, action) => {
            state.productInformation.productCode = action.payload;
        },
        setWorkOrderId: (state, action) => {
            state.productInformation.workOrderId = action.payload;
        },
        addProductInformation(state, action) {
            state.enamelPaintingForm.totalCount += parseInt(action.payload.hungCount);
            state.enamelPaintingForm.rows.unshift(action.payload);
            state.productInformation = initialState.productInformation;
        },
        removeRow(state, action) {
            // decrement the total count by the hung number
            state.enamelPaintingForm.rows.forEach(row => {
                if(row.rowId === action.payload){
                    state.enamelPaintingForm.totalCount -= row.hungCount
                    return
                }
            })

            state.enamelPaintingForm.rows = state.enamelPaintingForm.rows.filter(row => row.rowId !== action.payload);
        },
        confirm(state, action) {
            const { name, surname, role } = action.payload
            state.enamelPaintingForm.confirmData[role] = true;
            state.enamelPaintingForm.confirmData.name = `${name} ${surname} `
        },
        setEnamelPaintingData(state, action) {
            state.enamelPaintingForm[action.payload.label] = action.payload.value
        },
        clearEnamelPaintingForm: (state) => initialState,
        setEnamelPaintingCounter(state, action) {
            state.enamelPaintingForm.enamelPaintingFormId = parseInt(action.payload) + 1
        }

    },
    extraReducers: (builder) => {
        // todo: do we need this
        builder.addCase(PURGE, (state) => {
            return initialState
        });
    },
})

export const enamelPaintingFormActions = enamelPaintingFormSlice.actions;
export default enamelPaintingFormSlice.reducer;